var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.8 18",
    style: {
      enableBackground: "new 0 0 20.8 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M17.2,13H3.6c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7h13.6c0.9,0,1.7-0.8,1.7-1.7C18.9,13.7,18.1,13,17.2,13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M17.2,7.3H3.6C2.6,7.3,1.9,8.1,1.9,9c0,0.9,0.8,1.7,1.7,1.7h13.6c0.9,0,1.7-0.8,1.7-1.7C18.9,8.1,18.1,7.3,17.2,7.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M1.9,3.3c0-0.9,0.8-1.7,1.7-1.7h13.6c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7H3.6C2.6,5,1.9,4.3,1.9,3.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMenu);
export default __webpack_public_path__ + "static/media/picto-menu.9750c758.svg";
export { ForwardRef as ReactComponent };